import { Box, styled } from '@mui/material';

import {
  DCardContainerStyles,
  DegreeContainerStyles,
} from './DiplomaCard.types';

const DCInfoMarginTop = 70;

export const DCardContainer = styled('div')(
  ({ blockShadow, background }: DCardContainerStyles) => ({
    width: '320px',
    height: '340px',

    marginLeft: '24px',

    boxShadow: `1px 1px 8px 1px ${blockShadow}`,
    borderRadius: '6px',

    backgroundColor: background,

    position: 'relative',

    '@media screen and (min-width: 1920px)': {
      width: '420px',
      height: '450px',
    },

    '@media screen and (max-width: 1280px)': {
      marginLeft: '16px',
      width: '250px',
      height: '300px',
    },

    '@media screen and (max-width: 640px)': {
      width: '100%',
      marginLeft: 0,
    },
  }),
);

export const DCInfoContainer = styled(Box)(() => ({
  width: '100%',
  height: `calc(100% - ${DCInfoMarginTop}px)`,
  marginTop: `${DCInfoMarginTop}px`,
  padding: '12px 24px',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  boxSizing: 'border-box',
}));

export const DCCharacteristicContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',
}));

export const DegreeContainer = styled('div')(
  ({ elementShadow, backgroundReverse }: DegreeContainerStyles) => ({
    top: '12px',
    left: '-24px',

    padding: '12px',
    borderRadius: '0 6px 6px 0',
    backgroundColor: backgroundReverse,
    boxShadow: `4px 6px 6px 0px ${elementShadow}`,

    position: 'absolute',

    '@media screen and (max-width: 640px)': {
      left: '-12px',
      fontSize: '16px',
    },
  }),
);

export const DescriptionContainer = styled(Box)(() => ({
  display: 'flex',

  fontFamily: '"SignikaLight", sans-serif',
}));
